<div class="page-container">

  <a mat-button
     routerLink="/statistics"
     [state]="{ restoreSearch: true }"
     class="back-button">
    <mat-icon>arrow_back</mat-icon>
    Volver al buscador
  </a>

  <div *ngIf="isLoading$ | async" class="main-loader-container">
    <mat-spinner diameter="60"></mat-spinner>
    <span>Cargando datos del equipo...</span>
  </div>

  <div *ngIf="!(isLoading$ | async) && (teamInfo$ | async) as teamInfo">

    <app-team-detail-header [teamInfo]="teamInfo"></app-team-detail-header>

    <div class="season-selector-wrapper">
      <mat-form-field appearance="outline" class="season-selector">
        <mat-label>Temporada</mat-label>
        <mat-select
          [value]="selectedSeasonId$ | async"
          (selectionChange)="onSeasonChange($event)"
          [disabled]="!(seasons$ | async) || (seasons$ | async)!.length === 0">

          <mat-option *ngFor="let season of (seasons$ | async)" [value]="season.id">
            {{ season.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="season-content-wrapper">

      <div *ngIf="isLoadingSeasonData$ | async" class="season-loader-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <div class="season-content" [class.loading]="isLoadingSeasonData$ | async">

        <app-team-season-summary
          [stats]="selectedSeasonStats$ | async">
        </app-team-season-summary>

        <div class="main-grid">

          <app-team-roster-stats
            [roster]="roster$ | async">
          </app-team-roster-stats>

          <app-team-match-list
            [matchesResult]="matchesResult$ | async"
            [isLoading]="isLoadingSeasonData$ | async"
            (pageChanged)="onPaginateMatches($event)">
          </app-team-match-list>

        </div>
      </div>
    </div>

  </div>
</div>
